import React from 'react'
import { cn } from '@/lib/utils'

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string
  label?: string
}

export function Textarea({
  className,
  error,
  label,
  id,
  ...props
}: TextareaProps) {
  const textareaId = id || `textarea-${Math.random().toString(36).substr(2, 9)}`

  return (
    <div className="space-y-2">
      {label && (
        <label htmlFor={textareaId} className="block text-sm font-medium text-brand-gray">
          {label}
        </label>
      )}
      <textarea
        id={textareaId}
        className={cn(
          'form-textarea w-full px-3 py-2 border border-brand-gray/30 rounded-monumenta-sm',
          'bg-brand-dark-lighter text-white placeholder-brand-gray',
          'focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-brand-primary',
          'hover:border-brand-gray/50 transition-colors duration-200',
          'resize-vertical min-h-[80px]',
          error && 'border-error focus:ring-error focus:border-error',
          className
        )}
        {...props}
      />
      {error && (
        <p className="text-error text-sm">{error}</p>
      )}
    </div>
  )
}